import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SaleProductPaginatedService} from '../../../impl/service/saleProductPaginated.service';
import {Operator, UrlParameter} from '../../../../../../../shared/utils/url.builder';
import {SaleProductModel} from '../../entity/saleProduct.model';
import {SaleModel} from '../../../../../api/entity/sale.model';
import {SaleSummaryModel} from '../../../../../api/entity/saleSummary.model';
import {SaleFindOneByIdService} from '../../../../../impl/service/SaleFindOneById.service';
import {DialogController} from "../../../../../../common/dialog/dialogController";
import {
    SaleChangeMultipleProductsPriceDialogComponent
} from "../sale-change-multiple-products-price-dialog/sale-change-multiple-products-price-dialog.component";
import {
    SaleProductAddDialogComponent
} from "../../../../../api/component/sale-product-add-dialog/sale-product-add-dialog.component";

@Component({
    selector: 'app-sale-products-card',
    templateUrl: './sale-products-card.component.html',
    providers: [
        SaleProductPaginatedService,
        SaleFindOneByIdService,
    ]
})
export class SaleProductsCardComponent implements OnInit, OnChanges {

    @Input() saleId: number;
    @Input() title = 'Produits';
    @Output() productDeletedEvent: EventEmitter<SaleProductModel> = new EventEmitter<SaleProductModel>();
    @Output() saleLoadedEvent: EventEmitter<SaleSummaryModel> = new EventEmitter<SaleSummaryModel>();

    urlParameters: UrlParameter[] = [];
    sale: SaleModel;

    constructor(public service: SaleProductPaginatedService,
                public saleService: SaleFindOneByIdService,
                private dialogController: DialogController) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['saleId']) {
            this.urlParameters = [];
            if (this.saleId) {
                this.urlParameters = [
                    new UrlParameter('sale.id', this.saleId, Operator.EQUALS),
                ];
            }
        }
    }

    refresh() {
        this.service.refresh();
        this.sale = undefined;
        this.saleService.reload();
    }

    productDeleted(entity: SaleProductModel) {
        this.refresh();
        this.productDeletedEvent?.emit(entity);
    }
    saleLoaded(entity: SaleModel) {
        this.sale = entity;
        this.saleLoadedEvent.emit(entity.summary);
    }

    editMultiple() {
        this.dialogController.open(SaleChangeMultipleProductsPriceDialogComponent, {
            saleId: this.saleId
        }, {
            title: 'Modifier plusieurs prix',
            width: '95%'
        }).afterClosed()
            .toPromise()
            .then(() => this.refresh());
    }

    addProduct() {
        this.dialogController.open(SaleProductAddDialogComponent, {
            sale: this.sale.summary
        }, {
         title: 'Ajouter un produit',
         width: '95%'
        }).afterClosed().toPromise()
            .then(() => this.refresh());
    }
}
